// client/src/components/Hero/Hero.js

import React from 'react';
import './Hero.css';
import heroImage from '../../assets/hero-image.jpg';

const Hero = () => {
  return (
    <section id="hero" className="section hero-section">
      <div className="hero-content-grid">
        
        {/* --- COLUMN 1: TEXT & BUTTON --- */}
        <div className="hero-text">
          <h1 className="hero-title animate-fade-in-up">
            Om Nidhi Productions
          </h1>

          {/* --- THIS IS THE NEW SUMMARY BLOCK --- */}
          <blockquote className="hero-summary animate-fade-in-up">
            A visionary film and media house dedicated to crafting high-quality,
            inspiring, and meaningful visual content that resonates across
            generations.
          </blockquote>
          {/* (You can change the text inside the blockquote) */}

          <p className="hero-subtitle animate-fade-in-up">
            Crafting Cinematic Stories & Digital Experiences
          </p>
          <a
            href="/register"
            className="hero-button animate-fade-in-up"
          >
            Register Now
          </a>
        </div>

        {/* --- COLUMN 2: IMAGE --- */}
        <div className="hero-image-container animate-fade-in-right">
          <img src={heroImage} alt="Om Nidhi Production Studio" />
        </div>

      </div>
    </section>
  );
};

export default Hero;